import { Avatar, Grid, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { OrderCard } from './OrderCard';
import { IEquipmentPrevOrder } from 'API';
import React, { useState } from 'react';
import { OrderStatusDialog } from '../../OrderStatusDialog';
import { BigButton, LeftArrowLarge } from 'Images';

interface IOrderListDesktopProps {
  recentOrders: IEquipmentPrevOrder[];
}

const maxOrdersCount = 10;

export const OrderListDesktop = ({ recentOrders }: IOrderListDesktopProps) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedValue, setSelectedValue] = useState<IEquipmentPrevOrder>();
  const [showAllOrders, setShowAllOrders] = useState(false);

  const handleOpenModal = (p: IEquipmentPrevOrder) => {
    setSelectedValue(p);
    setOpenDialog(true);
  };
  const handleClose = () => {
    setSelectedValue(undefined);
    setOpenDialog(false);
  };

  const gridTitles = [
    dictionary.RecentOrders.date,
    dictionary.RecentOrders.orderId,
    dictionary.RecentOrders.productsCount,
    dictionary.RecentOrders.status,
  ];

  const getFilteredOrders = () => {
    if (recentOrders.length <= maxOrdersCount) return recentOrders;
    return recentOrders?.slice(
      0,
      showAllOrders ? recentOrders.length : maxOrdersCount
    );
  };

  return (
    <>
      <Grid
        component={'ul'}
        padding={0}
        container
        item
        xs={12}
        gap={2}
        justifyContent={'start'}
        sx={{ width: '100%', mb: '40px', bgcolor: 'transparent' }}
      >
        {recentOrders &&
          getFilteredOrders().map((item, index) => (
            <OrderCard
              key={index}
              item={item}
              onShowOrderDetailsClick={() => handleOpenModal(item)}
              titles={gridTitles}
            />
          ))}
      </Grid>

      {/* BUTTON SHOW ALL ORDERS */}
      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          p: '23px 0',
        }}
      >
        {recentOrders &&
          recentOrders.length > maxOrdersCount &&
          !showAllOrders && (
            <Stack
              onKeyUp={(e: React.KeyboardEvent) => {
                e.key === 'Enter' && setShowAllOrders(true);
              }}
              tabIndex={0}
              onClick={() => setShowAllOrders(true)}
              direction={'row'}
              spacing={1}
              sx={{
                width: 'fit-content',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                m: '10px 50px',
              }}
              role='button'
            >
              <Typography variant='body5' color={'primary'}>
                {dictionary.RecentOrders.showMoreOrders}
              </Typography>
              <Avatar
                src={BigButton}
                alt=''
                sx={{
                  width: '46px',
                  height: '50px',
                  transform: 'rotate(270deg)',
                }}
              />
            </Stack>
          )}
      </Grid>

      {openDialog && selectedValue && (
        <OrderStatusDialog
          onClose={handleClose}
          open={openDialog}
          item={selectedValue}
        />
      )}
    </>
  );
};
